/**
 * useAcceptInvitation Hook
 *
 * React Query mutation hook for accepting a user invitation.
 */

import { useMutation } from '@tanstack/react-query';
import type { UseMutationResult } from '@tanstack/react-query';
import { userService } from '../../../api/user.service';
import type { UserAcceptInvitationDTO, UserSanitized } from '../../../types/user.types';
import { getErrorMessage } from '../../../lib/utils/errors';

/**
 * Hook for accepting an invitation
 */
export const useAcceptInvitation = (
  tenantId: string
): UseMutationResult<UserSanitized, Error, UserAcceptInvitationDTO> => {
  return useMutation<UserSanitized, Error, UserAcceptInvitationDTO>({
    mutationFn: (data) => {
      console.log('[useAcceptInvitation] Accepting invitation with token');
      return userService.acceptInvitation(tenantId, data);
    },
    onSuccess: (user) => {
      console.log('[useAcceptInvitation] Invitation accepted successfully for user:', user.email);
    },
    onError: (error) => {
      console.error('[useAcceptInvitation] Failed to accept invitation:', getErrorMessage(error));
    },
  });
};
